import { useSendingEmails } from "@api/sendingEmail.api";
import { useCanManageWorkspace } from "@hooks/permissions/useCanManageWorkspace";
import { useWorkspaceSendingOwner } from "@hooks/useWorkspaceSendingOwner";

export function useWorkspaceSendingEmails() {
    const owner = useWorkspaceSendingOwner();
    const canManageWorkspace = useCanManageWorkspace();
    return useSendingEmails(owner, { enabled: canManageWorkspace });
}
